module.exports = __webpack_public_path__ + "static/logo.9fd35dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/logo.png
// module id = 566
// module chunks = 35783957827783